import type { ZoneType } from "../api/types";

/**
 * G-84 — a storage box IS a zone, and that is the whole reason it has
 * contents, a FIFO position and a place in every balance query without a
 * second ledger. The cost of that choice is this: a box turns up in every
 * list of zones ever written, including the ones that ask a person where to
 * put stock.
 *
 * No picker may offer one. Stock enters a box by scanning its label on the
 * tablet (OD-50) and leaves it from the box's own card, both of which record
 * WHICH physical box and WHO — a manager receiving a delivery straight into
 * `BOX-000017` from the CRM would move stock with none of that, and the box's
 * contents would be right by accident at best.
 *
 * The server's half of this rule is `SHELF_ZONE_TYPES` in `domain-enums.ts`,
 * which bounds the zone move itself. This is the UI's half: never offer what
 * the server would be right to refuse.
 */
export function isShelfZone(zone: { zoneType: ZoneType }): boolean {
  return zone.zoneType !== "BOX";
}

/** The shelf zones of a list, boxes dropped. Order is preserved. */
export function shelfZonesOnly<T extends { zoneType: ZoneType }>(zones: T[]): T[] {
  return zones.filter(isShelfZone);
}
